import { forwardRef, type PropsWithChildren } from "react";

import clsx from "clsx";

import {
  QuickSelectNoticeButton,
  type QuickSelectNoticeButtonProps,
} from "./quick-select-notice-button";

export const QuickSelectNoticeIconButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<QuickSelectNoticeButtonProps>
>(({ size = "lg", className, children, ...props }, ref) => {
  return (
    <QuickSelectNoticeButton
      ref={ref}
      className={clsx(
        "rounded-md p-0",
        {
          "w-8": size === "sm",
          "w-9": size === "lg",
        },
        className,
      )}
      size={size}
      {...props}
    >
      {children}
    </QuickSelectNoticeButton>
  );
});
